import type { MappedCatalogItem } from 'entities/CatalogItem/model/types/CatalogItemSchema';
import type {
    AddCustomListGlobalItem,
    AddCustomListItem,
    AddCustomListItemsData,
} from 'entities/CustomList';

/**
 * Maps multiselect state to POST /v1/custom-lists/:id/items body.
 * Each line is routed by **stored fields** (`catalogItemId` vs `uid`), not by UI tab —
 * same split as add-to-order.
 */
export const buildAddCustomListItemsPayload = (
    selectedItems: Record<string, Partial<MappedCatalogItem>>,
): AddCustomListItemsData => {
    const items: AddCustomListItem[] = [];
    const globalItems: AddCustomListGlobalItem[] = [];

    for (const [selectionMapKey, item] of Object.entries(selectedItems)) {
        // Already on the list — qty is synced live; do not re-add on submit.
        if (item.customListItemId) {
            continue;
        }

        const targetQuantity = item.qty && item.qty > 0 ? item.qty : 1;

        if (item.catalogItemId != null && item.catalogItemId !== '') {
            items.push({
                catalogItemId: item.catalogItemId,
                targetQuantity,
            });
            continue;
        }

        const itemUuid = item.uid ?? selectionMapKey;
        if (itemUuid) {
            globalItems.push({
                itemUuid,
                targetQuantity,
            });
        }
    }

    const data: AddCustomListItemsData = {};

    if (items.length > 0) {
        data.items = items;
    }

    if (globalItems.length > 0) {
        data.globalItems = globalItems;
    }

    return data;
};
